import { lazy, ComponentType } from 'react';

export const lazyWithRetry = (componentImport: () => Promise<{ default: ComponentType<any> }>) =>
    lazy(() => {
        return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
            const hasRefreshed = JSON.parse(
                window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
            );

            componentImport()
                .then((component) => {
                    window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
                    resolve(component);
                })
                .catch((error) => {
                    if (!hasRefreshed) {
                        window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
                        return window.location.reload();
                    }
                    reject(error);
                });
        });
    });
